import { render } from "./viewPayment.vue?vue&type=template&id=c79100f6&scoped=true"
import script from "./viewPayment.vue?vue&type=script&lang=js"
export * from "./viewPayment.vue?vue&type=script&lang=js"

import "./viewPayment.vue?vue&type=style&index=0&id=c79100f6&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c79100f6"]])

export default __exports__